module.exports = "/_next/static/images/loading-dummy-73b7f8f476757cfda1be5629c6cca172.gif";